import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Complaint from '../../models/Complaint';


export interface ComplaintDetailState extends ApiState {
  complaint?: Complaint
}

export default requestReducer<ComplaintDetailState>('COMPLAINT_DETAIL')
